export const setBicValueFromIban = async (ibanValue, setFieldValue, validateIBAN) => {
  try {
    if (ibanValue && ibanValue.length >= 10 && ibanValue.length <= 40) {
      const { isValid, paymentData } = await validateIBAN(ibanValue);
      if (isValid) {
        setFieldValue('bic', paymentData.bic);
        return;
      }
    }

    setFieldValue('bic', '');
  } catch (error) {
    setFieldValue('bic', '');
  }
};
